export default __webpack_public_path__ + "static/media/country.60c8afd5.png";